"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomainPriceInfo = void 0;
var _availabilityStatus = require("./constants/availabilityStatus");
var _PriceHelper = require("./PriceHelper");
/* eslint-disable complexity */

const getDomainPriceInfo = ({
  domain,
  product,
  market,
  currency
}) => {
  const {
    ListPrice: listPrice,
    ListPriceDisplay: listPriceDisplay,
    CurrentPrice: currentPrice,
    CurrentPriceDisplay: currentPriceDisplay,
    OneYearSalePrice: oneYearSalePrice,
    AdditionalYearsPrice: additionalYearsPrice,
    RenewalPrice: renewalPrice
  } = product.PriceInfo || {};
  const hasDiscount = currentPrice && listPrice && currentPrice !== listPrice;
  const availabilityLabel = domain?.AvailabilityLabel;
  const isAuction = availabilityLabel === _availabilityStatus.AvailabilityStatus.Auction;
  const isAftermarketPremium = availabilityLabel === _availabilityStatus.AvailabilityStatus.Premium;
  const isRegPremium = availabilityLabel === _availabilityStatus.AvailabilityStatus.RegPremium;
  const noFirstYearDiscount = Boolean(currentPrice && additionalYearsPrice && currentPrice === additionalYearsPrice);
  const samePriceEachYear = !isAuction && !isAftermarketPremium && !isRegPremium && noFirstYearDiscount;
  const isRenewalPriceHigher = renewalPrice > currentPrice;
  const isPriceConsistent = samePriceEachYear && !isRenewalPriceHigher;
  return {
    additionalYearsPrice: additionalYearsPrice || null,
    aftermarketPremiumPricingDisplay: domain?.PriceDisplay,
    annualPricingDisplay: {
      currentPriceDisplay: currentPriceDisplay || null,
      listPriceDisplay: hasDiscount && listPriceDisplay || null
    },
    currentPrice: currentPrice || null,
    hasDiscount: !!hasDiscount,
    isPriceConsistent,
    listPrice: hasDiscount && listPrice || null,
    monthlyPricingDisplay: {
      currentPriceDisplay: currentPrice && (0, _PriceHelper.convertYearlyPriceToMonthlyPrice)(currentPrice, market, currency) || null,
      listPriceDisplay: hasDiscount && (0, _PriceHelper.convertYearlyPriceToMonthlyPrice)(listPrice, market, currency) || null
    },
    oneYearSalePrice: oneYearSalePrice || null,
    samePriceEachYear,
    terms: {
      promoRegLengthFlag: product.PriceInfo.PromoRegLengthFlag
    }
  };
};
exports.getDomainPriceInfo = getDomainPriceInfo;